/*eslint-disable*/ export const messages = JSON.parse("{\"radio-group.validation.required\":[\"Valitse vaihtoehto.\"],\"radio-group.label.optional\":[\"Valinnainen\"]}");
//# sourceMappingURL=messages.mjs.map